"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Virtual any type for the property decorator.
 */
var Any = /** @class */ (function () {
    function Any() {
    }
    return Any;
}());
exports.Any = Any;
//# sourceMappingURL=any.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/json2typescript/src/json2typescript/any.js
// module id = 297
// module chunks = 0